export const DAY_NAMES = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
] as const;

export const DAY_KEYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
] as const;

export const MINUTES_PER_DAY = 1440;
export const MINUTES_PER_WEEK = 10_080;

// Shared green/red treatment for availability blocks on the month calendar
// and the weekly pattern grid.
export const AVAILABILITY_STATUS_CHIP_CLASS = {
    available:
        'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
    unavailable: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
} as const;
